import { Texture } from './Texture';
import { Context } from '../context/Context';

export class PlaceHolderTexture extends Texture {
  constructor(ctx: Context) {
    super();

    this.init(ctx);
  }

  protected init(ctx: Context): void {
    const gl = ctx.gl;

    let texture = gl.createTexture();

    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.LUMINANCE,
      2,
      2,
      0,
      gl.LUMINANCE,
      gl.UNSIGNED_BYTE,
      new Uint8Array([
        255, 255, 255, 255, 0.0, 0.0, 0.0, 255, 0.0, 0.0, 0.0, 255, 255, 255, 255, 255,
      ]),
    );

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);

    gl.bindTexture(gl.TEXTURE_2D, null);

    this.glTexture = texture;
  }
}
